import http from "../request/index";

export default {
  async getEnvData(params) {
    return await http.get(`/api/drawform/index/activityId/${params.id}`);
  },
  async submit(params) {
    return await http.post("/api/drawform/upload", params);
  },
  async upload(params, config) {
    return await http.post("/api/common/uploadImg", params, config);
  }
};
